<template>
  <div class="contenedor-exitos">
    <div class="d-flex justify-content-center flex-wrap">
      <div v-for="(item, index2) in clientesRelacionados.slice(0,5)" :key="index2">
        <img :src="item.imagen" :style="{width: width_img }" class="mx-1" :title="item.nombre" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      clientesRelacionados: [],
      width_img: this.img_width + 'px'
    };
  },
  computed: {
    ...mapState(["cliente_producto", "Clientes"])
  },
  created() {
    this.obtenerClientes();
  },
  methods: {
    obtenerClientes() {
      /* -- Relación de Cliente-Producto */
      this.cliente_producto.forEach(item => {
        if (item.id_producto == this.id_prod) {
          this.Clientes.forEach(item2 => {
            if (item2.id == item.id_cliente) {
              this.clientesRelacionados.push(item2);
            }
          });
        }
      });
      /* ------------ */
    }
  },
  props: ["id_prod", "img_width"]
};
</script>